import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", { viewBox: "0 0 348 90" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M87.4 25.4L63.4 1c-.6-.6-1.5-1-2.4-1H27.3c-.9 0-1.7.4-2.4 1L.9 25.4c-.6.6-.9 1.4-.9 2.3v34.6c0 .9.3 1.7.9 2.3l24 24.4c.6.6 1.5 1 2.4 1h33.8c.9 0 1.7-.4 2.4-1l24-24.4c.6-.6.9-1.4.9-2.3V27.7c-.1-.9-.4-1.7-1-2.3zm-2.1 35.8c0 .7-.3 1.4-.8 1.9L62 86.1c-.5.5-1.2.8-2 .8H28.3c-.7 0-1.5-.3-2-.8L3.8 63.2c-.5-.5-.8-1.2-.8-2V28.8c0-.7.3-1.4.8-1.9l22.5-23c.5-.5 1.2-.8 2-.8h31.8c.7 0 1.5.3 2 .8l22.5 22.9c.5.5.8 1.2.8 1.9v32.5zm-9-30.8c.5.5.7 1.1.7 1.8V34H33.9c-.9 0-1.6-.7-1.6-1.6 0-.9.7-1.6 1.6-1.6h38.6L57.1 15.1c-.4-.4-.9-.6-1.4-.6H32.6c-.5 0-1 .2-1.4.6L14.8 31.8c-.4.4-.6.9-.6 1.4v10.4H77v14.3c0 .7-.3 1.3-.7 1.8l-17.8 18c-.5.5-1.1.8-1.8.8H31.6c-.7 0-1.3-.3-1.8-.8L12 59.6c-.5-.5-.7-1.1-.7-1.8v-1.5h43.1c.9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6H16l15.2 15.4c.4.4.9.6 1.4.6h23.1c.5 0 1-.2 1.4-.6l16.4-16.7c.4-.4.6-.9.6-1.4V46.7H11.3V32.2c0-.7.3-1.3.7-1.8l17.8-18.1c.5-.5 1.1-.8 1.8-.8h25.1c.7 0 1.3.3 1.8.8l17.8 18.1z",
    fill: "#ef8a22"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M324.3 34.7v8.2h22.8V47h-22.8v8.2h23.4v4.5h-27.9V30.2h27.9v4.5h-23.4zM155.4 44.9l-11.5-14.7h-5.2L153 48.5v11.2h4.5V48.5l14.6-18.3h-5.3l-11.4 14.7zm40.1-2.1h-11.7c-3.8 0-4.8-1.1-4.8-4.1 0-3 1-4.1 4.8-4.1h20.4v-4.5h-20.4c-7 0-9.3 2.3-9.3 8.1v.9c0 5.3 2.2 7.8 9.3 7.8h11.7c4.1 0 5.1.9 5.1 4.2 0 3.2-1 4.1-5.3 4.1h-20.2l.1 4.5h20.3c7.2 0 9.7-2.2 9.7-8.4v-.9c0-5.2-2.5-7.6-9.7-7.6zm48.7-3.1v10.4c0 7.3-2.1 9.6-9.1 9.6h-24.4V30.2h24.4c7 0 9.1 2.3 9.1 9.5zm-4.5.1c0-4-1.2-5.1-4.6-5.1h-19.9v20.6h19.9c3.6 0 4.6-1.1 4.6-5.1V39.8zm23.5 5.1l-11.5-14.7h-5.2l14.3 18.3v11.2h4.5V48.5l14.6-18.3h-5.3l-11.4 14.7zm47.1 8.3l-22.4-23.1H283v29.5h4.3V36.4l22.8 23.4h4.4V30.2h-4.3v23zM126.6 42.8h-11.7c-3.8 0-4.8-1.1-4.8-4.1 0-3 1-4.1 4.8-4.1h20.2l-3.5-4.5h-16.7c-7 0-9.3 2.3-9.3 8.1v.9c0 5.3 2.2 7.8 9.3 7.8h11.7c4.1 0 5.1.9 5.1 4.2 0 3.2-1 4.1-5.3 4.1h-20.2l-.1 4.5h20.4c7.2 0 9.7-2.2 9.7-8.4v-.9c.1-5.2-2.4-7.6-9.6-7.6z",
    fill: "#ffffff"
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2 font-weight-medium" }, "My Account", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_responsive = _resolveComponent("v-responsive")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_menu_products = _resolveComponent("menu-products")!
  const _component_menu_user = _resolveComponent("menu-user")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    density: "compact",
    color: "secondary"
  }, {
    default: _withCtx(() => [
      (_ctx.isAuthenticated)
        ? (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
            key: 0,
            class: "ms-1",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('toggle-drawer')), ["stop"]))
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_responsive, {
        class: "ml-1",
        "aspect-ratio": 348 / 90,
        width: "116",
        "max-width": "116",
        height: "30"
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _hoisted_2,
      _createVNode(_component_v_spacer),
      _createVNode(_component_menu_products),
      _createVNode(_component_menu_user)
    ]),
    _: 1
  }))
}